import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * URL e anon key são públicas por design do Supabase, mas ficam no .env do
 * backend pra existir UMA fonte de verdade — o front busca em /config (rota
 * aberta) em vez de duplicar os valores num .env próprio que sairia de sincronia.
 */
export interface PublicConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
  allowedEmailDomains: string[];
}

let client: SupabaseClient | null = null;
let config: PublicConfig | null = null;

export async function initSupabase(): Promise<{ client: SupabaseClient; config: PublicConfig }> {
  if (client && config) return { client, config };

  const res = await fetch('/config');
  if (!res.ok) throw new Error(`Não foi possível carregar /config (HTTP ${res.status}).`);
  config = (await res.json()) as PublicConfig;

  client = createClient(config.supabaseUrl, config.supabaseAnonKey, {
    auth: { persistSession: true, autoRefreshToken: true, storageKey: 'sb-revops-auth' },
  });
  return { client, config };
}

export function getSupabase(): SupabaseClient {
  if (!client) throw new Error('initSupabase() precisa rodar antes de getSupabase().');
  return client;
}

export function getConfig(): PublicConfig {
  if (!config) throw new Error('initSupabase() precisa rodar antes de getConfig().');
  return config;
}
